module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Model-Q-1148.b721c1bc.jpg";